// extracted by mini-css-extract-plugin
export var component = "PostsModuleButtonLayout-module--component--qzXcq";
export var filterForm = "PostsModuleButtonLayout-module--filterForm--qXadj";
export var item = "PostsModuleButtonLayout-module--item--ijVWK";
export var list = "PostsModuleButtonLayout-module--list--qOxfV";